<template>
  <layout page-title="User-Rechte">
    <section
      class="
        min-w-0
        flex-1
        h-full
        flex flex-col
        lg:order-last
        relative
        mt-5
      "
    >
      <!-- <visual-feedback></visual-feedback> -->

      <form @submit.prevent="submit" novalidate autocomplete="off">
        <div class="max-w-7xl pt-4 px-4 sm:px-6 lg:px-8">
          <div class="flex flex-col">
            <div
              class="
                -my-2
                py-2
                overflow-x-auto
                sm:-mx-6 sm:px-6
                lg:-mx-8 lg:px-8
              "
            >
              <!-- Page Header: start -->
              <div class="md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                  <h2
                    class="
                      text-2xl
                      font-light
                      leading-7
                      text-gray-900
                      sm:text-2xl sm:leading-9 sm:truncate
                    "
                  >
                    User-Rechte
                  </h2>
                </div>
                <div class="mt-4 flex md:mt-0 md:ml-4">
                  <Link :href="route('admin.users.index')" class="
                    inline-flex
                    items-center
                    px-4
                    py-2
                    border border-transparent
                    text-sm
                    font-medium
                    rounded-md
                    text-gray-500
                    bg-gray-300
                    shadow-sm
                    hover:bg-gray-400 hover:text-white
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-gray-400
                    mr-16
                  ">User-Übersicht</Link>
                </div>
                <div class="mt-4 flex md:mt-0 md:ml-4">
                  <submit-button
                    :sending="form.processing"
                    :validated="true"
                    :full-width="false"
                    >Speichern</submit-button
                  >
                </div>
              </div>
              <!-- Page Header: end -->

              <horizontal-divider />

              <div class="px-4 sm:px-6 lg:px-8">
                <div class="flex flex-col">
                  <div class="-my-2 -mx-4 sm:-mx-6 lg:-mx-8">
                    <div class="inline-block py-2 align-middle">
                      <!-- table: start -->

                      <table class="border-collapse mt-0">
                        <thead>
                          <tr>
                            <th></th>

                            <th
                              v-for="(permissionType, idx) in permissionTypes"
                              :key="idx"
                              class="py-1.5 px-2.5 h-36 whitespace-nowrap"
                            >
                              <div
                                class="
                                  w-8
                                  translate-x-[24px] translate-y-[50px]
                                  rotate-[315deg]
                                "
                              >
                                <span
                                  class="
                                    text-sm
                                    font-semibold
                                    text-gray-900
                                    border-b border-b-gray-300
                                    py-1.5
                                    px-2.5
                                  "
                                  >{{ permissionType.name }}</span
                                >
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(user, uidx) in users" :key="uidx">
                            <th
                              class="
                                text-sm
                                font-normal
                                text-gray-900
                                py-1.5
                                px-2.5
                                border-b border-b-gray-300
                                text-left
                              "
                            >
                              {{ user.name }}
                              <p v-if="user.partner" class="text-gray-400">{{ user.partner?.name || '' }}</p>
                            </th>
                            <td
                              v-for="(permissionType, idx) in permissionTypes"
                              :key="idx"
                              class="
                                w-8
                                text-center
                                py-2.5
                                px-1.5
                                border border-gray-300
                              "
                            >
                              <input
                                type="checkbox"
                                :checked="isChecked(user, permissionType)"
                                @click="
                                  setPermission($event, user, permissionType)
                                "
                                :disabled="disabled(user, permissionType)"
                                class="
                                  h-4
                                  w-4
                                  rounded
                                  border-gray-300
                                  text-markencode-blue
                                  focus:ring-markencode-blue
                                "
                                :class="disabled(user, permissionType) ? 'opacity-30' : ''"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- table: end -->
                    </div>
                  </div>
                </div>
              </div>


              <horizontal-divider />

              <!-- Page Footer: start -->
              <div class="md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                  <submit-button
                    :sending="form.processing"
                    :validated="true"
                    :full-width="false"
                    >Speichern</submit-button
                  >
                </div>
                <div class="mt-4 flex md:mt-0 md:ml-4">
                  
                </div>
              </div>
              <!-- Page Footer: end -->


            </div>
          </div>
        </div>
      </form>

    
    </section>

    
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import SubmitButton from '@/Shared/SubmitButton.vue';
import HorizontalDivider from '@/Shared/HorizontalDivider';
// import VisualFeedback from '@/Shared/VisualFeedback.vue';

export default {
  name: 'UserPermissions',

  components: {
    Layout,
    // VisualFeedback,
    SubmitButton,
    HorizontalDivider,
  },

  props: {
    users: Array,
    permissionTypes: Array,
    userPermissions: Object,
  },

  data() {
    return {
      form: this.$inertia.form({
        permissions: this.userPermissions,
      }),
    };
  },

  methods: {
    disabled(user, permissionType) {
      // if (user.id == this.$page.props.auth.user.id && permissionType.id == 'manage_users') {
      //   return true;
      // }

      if (this.form.processing) {
        return true;
      }

      return false;
    },

    isChecked(user, permissionType) {
      return this.form.permissions[user.id][permissionType.id];
    },

    setPermission(event, user, permissionType) {
      this.form.permissions[user.id][permissionType.id] =
        event.target.checked;
    },

    submit() {
      this.form.post(this.route('admin.users.permissions.store'), {
        preserveScroll: true,
      });
    },
  },
};
</script>